import { IToggle } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Toggle';
import { IPromotionState } from '../../../../reducers/v2';

export function mapToggle(toggle: IToggle): IPromotionState['toggle'] {
  return {
    checked: toggle.isChecked,
    disabled: toggle.isDisabled,
  };
}
